
/**
 * @param {string} method  请求的方法：get、post、delete、put
 * @param {string} url     请求的url:
 * @param {object} data    请求的参数
 * @param {object} params    请求的参数
 * @param {object} config  请求的配置
 * @returns {Promise}     返回一个promise对象，其实就相当于axios请求数据的返回值
 */

const onRequest: Function = (method: string, url: string, data?: any, params?: any, config?: any) => {
  method = method.toLowerCase();
  // console.log("接口请求封装",url,method,data,params,config)
  if (method == 'post') {
    return useDefaultRequest.post(url, data, {
      params: params || {},
      ...config
    });
  } else if (method == 'get') {
    return useDefaultRequest.get(url, {
      ...data
    });
  }
};

/**
 * 将Object转换成&key=value&key1=value1
 */
const toQueryPair = function (key: any, value: any) {
  if (typeof value == 'undefined') {
    return `&${key}=`;
  }
  return `&${key}=${value}`;
};
const parseParam = function (param: any) {
  if (Object.prototype.toString.call(param) !== '[object Object]') {
    return '';
  }
  let queryParam = '';
  for (const key in param) {
    if (param.hasOwnProperty(key)) {
      const value = param[key];
      queryParam += toQueryPair(key, value);
    }
  }
  // output key=value&key1=value1
  return queryParam.substr(1);
};
export { onRequest, parseParam };
